<!-- Buttons: delete, review -->
<div class="divflexend marginbottomminus12px padleft220px">
  <div class="maringright10px">
    <span class="font11px textalignright" *ngIf="ingredient">
      <span *ngIf="ingredient.id">
        <span class="colorgray">Created By:</span> {{ingredient.createdBy}}&nbsp;&nbsp;&nbsp;
        {{ingredient.creationDate|date: 'MM/dd/yyyy hh:mm:ss a'}}&nbsp;&nbsp;&nbsp;
        <span class="colorgray">Modified By:</span> {{ingredient.modifiedBy}}&nbsp;&nbsp;&nbsp;
        {{ingredient.lastModifiedDate|date: 'MM/dd/yyyy hh:mm:ss a'}}
      </span>
    </span>
  </div>

  <div class="maringright10px">
    <button mat-icon-button [ngStyle]="{'color':'orangered'}" (click)="copyProductIngredient()"
      matTooltip="Copy Ingredient Details {{prodIngredientIndex + 1}} to New Ingredient">
      <mat-icon>file_copy</mat-icon>
    </button>
  </div>

  <div>
    <button mat-icon-button [ngStyle]="{'color':'orangered'}"
      (click)="confirmDeleteProductIngredient(prodComponentIndex, prodLotIndex, prodIngredientIndex)"
      matTooltip="Delete Ingredient Details {{prodIngredientIndex + 1}}">
      <mat-icon>delete_forever</mat-icon>
    </button>
  </div>
</div>

<!--
    &nbsp;&nbsp;
    <button mat-icon-button [ngStyle]="{'color':'orangered'}" (click)="confirmReviewIngredient()"
      matTooltip="Click to Confirm Ingredient Details {{prodIngredientIndex + 1}} data has been Reviewed">
      <mat-icon>check_circle</mat-icon>
    </button>
    <span *ngIf="ingredient.reviewDate" class="colorgray font12px">Reviewed
      By:{{ingredient.reviewedBy}}&nbsp;{{ingredient.reviewDate|date: 'MM/dd/yyyy hh:mm:ss a'}}
    </span>
  -->

<!-- Display Ingredient -->
<fieldset class="border">
  <legend class="border">Ingredient Details&nbsp;<b><span class="colorgreen font17px">{{prodIngredientIndex +
        1}}</span></b>
  </legend>

  <div class="divflexrow">

    <mat-form-field class="col-4-1">
      <textarea matInput placeholder="Applicant Ingredient Name" [(ngModel)]="ingredient.applicantIngredName"
        name="applicantIngredName" rows="3">
    </textarea>
    </mat-form-field>

    <!-- Substance Selector for Substance/Ingredient Name -->
    <div class="col-4-1">
      <app-substance-selector (selectionUpdated)="ingredientNameUpdated($event)"
        eventCategory="substanceRelationshipRelatedSub" placeholder="Ingredient Name" header="Ingredient Name"
        [subuuid]="ingredientNameSubstanceUuid" [showMorelinks]="true">
      </app-substance-selector>

      <!-- Display Active Moiety of Ingredient Name -->
      <div class="margintop10px" *ngFor="let active of ingredientNameActiveMoiety; let activeIndex = index">
        <span class="font12px"><b>{{active}}</b></span>
        <span class="colorgray font11px">&nbsp;(Active Moiety)</span>
      </div>

    </div>

    <!-- Substance Selector for Basis of Strength Name -->
    <div class="col-4-1">
      <app-substance-selector (selectionUpdated)="basisOfStrengthUpdated($event)"
        eventCategory="substanceRelationshipRelatedSub" placeholder="Basis of Strength" header="Basis of Strength"
        [subuuid]="basisOfStrengthSubstanceUuid" [showMorelinks]="true">
      </app-substance-selector>

      <!-- Display Active Moiety -->
      <div class="margintop10px" *ngFor="let active of basisOfStrengthActiveMoiety; let activeIndex = index">
        <span class="font12px"><b>{{active}}</b></span>
        <span class="colorgray font11px">&nbsp;(Active Moiety)</span>
      </div>

    </div>

    <!-- Ingredient Name (OLD CODE)-->
    <!--
    <div class="col-1-4 flex-column related-substance">
      <div class="related-substance-border">
        <app-substance-search-selector (selectionUpdated)="ingredientNameUpdated($event)"
          (showMessage)="showMessageIngredientName($event)" (searchValueOut)="searchValueOutChange($event)"
          eventCategory="ingredName" placeholder="Ingredient Name" header="Ingredient Name" [subuuid]="substanceUuid">
        </app-substance-search-selector>

        <div *ngIf="ingredientNameMessage" class="colorred font12px">
          {{ingredientNameMessage}}
        </div>

        <!- - Display Ingredient Name Details - ->
        <div class="padall5px fontfamilyhelvetica">
          <div *ngIf="ingredientName">
            <span class="colormaroon"><b>{{ingredientName}}</b></span>
            <br>
            <!-- Display Active Moiety - ->
            <div *ngFor="let active of ingredientNameActiveMoiety; let activeIndex = index">
              {{active}} <span class="colorgray font11px">(Active Moiety)</span>
            </div>
          </div>
          <div *ngIf="ingredient.substanceKey">
            <span class="colororange">{{ingredient.substanceKey}}</span><span class="colorgray font11px">
              ({{ingredient.substanceKeyType}})</span>
            <br>
            <button mat-icon-button color="primary" (click)="confirmDeleteIngredientName()"
              matTooltip="Delete Ingredient Name {{prodIngredientIndex + 1}}">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    -->

    <!-- Basis of Strength -->
    <!--
    <div class="col-1-4 flex-column related-substance">
      <div class="related-substance-border">
        <app-substance-search-selector (selectionUpdated)="basisOfStrengthUpdated($event)"
          (showMessage)="showMessageBasisOfStrength($event)" (searchValueOut)="searchValueBasisOutChange($event)"
          eventCategory="substanceRelationshipRelatedSub" placeholder="Basis Of Strength" header="Basis Of Strength"
          [subuuid]="basisOfStrengthSubstanceUuid">
        </app-substance-search-selector>

        <div *ngIf="basisOfStrengthMessage" class="colorred font12px">
          {{basisOfStrengthMessage}}
        </div>

        <!- - Display Basis of Strength Details - ->
        <div class="padall5px fontfamilyhelvetica">
          <div *ngIf="basisOfStrengthIngredientName">
            <span class="colormaroon"><b>{{basisOfStrengthIngredientName}}</b></span>
            <br>
            <!- - Display Active Moiety - ->
            <div *ngFor="let active of basisOfStrengthActiveMoiety; let activeIndex = index">
              {{active}} <span class="colorgray font11px">(Active Moiety)</span>
            </div>
          </div>

          <div *ngIf="ingredient.basisOfStrengthSubstanceKey">
            <span class="colororange">{{ingredient.basisOfStrengthSubstanceKey}}</span><span class="colorgray font11px">
              ({{ingredient.basisOfStrengthSubstanceKeyType}})</span>
            <br>
            <button mat-icon-button color="primary" (click)="confirmDeleteBasisOfStrength()"
              matTooltip="Delete Basis of Strength {{prodIngredientIndex + 1}}">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    -->

    <div class="col-4-1">
      <label>Ingredient Location</label><br>
      <span *ngFor="let data of locationList; let i=index">
        <mat-checkbox class="font11px" #checkBox [value]="data.value" [(ngModel)]="data.checked" name="data.value"
          (change)="setSelectedIngredientLocation(data, checkBox)">
          {{data.value}}
        </mat-checkbox>
        &nbsp;
      </span>

      <!-- Display Text Box if "Other" is selected from the textbox -->
      <div class="marginleft60p margintop20px" *ngIf="isIngredLocationOtherSelected && isIngredLocationOtherSelected == true">
        <mat-form-field class="width120px">
          <input matInput placeholder="Other Ingredient Location" [(ngModel)]="ingredient.ingredientLocationText" name="ingredientLocationText" />
        </mat-form-field>
      </div>

    </div>

  </div> <!-- row-->

  <div class="form-row margintop20px">
    <app-cv-input class="col-4-1" domain="INGREDIENT_TYPE" title="Ingredient Type" name="ingredientType"
      [model]="ingredient.ingredientType" (valueChange)="ingredient.ingredientType = $event">
    </app-cv-input>

    <app-cv-input class="col-4-1" domain="PROD_INGREDIENT_FUNCTION" title="Ingredient Function"
      name="ingredientFunction" [model]="ingredient.ingredientFunction"
      (valueChange)="ingredient.ingredientFunction = $event">
    </app-cv-input>

    <app-cv-input class="col-4-1" domain="PROD_GRADE" title="Grade" name="grade" [model]="ingredient.grade"
      (valueChange)="ingredient.grade = $event">
    </app-cv-input>

    <app-cv-input class="col-4-1" domain="PROD_RELEASE_CHARACTERISTIC" title="Release Characteristics"
      name="releaseCharacteristic" [model]="ingredient.releaseCharacteristic"
      (valueChange)="ingredient.releaseCharacteristic = $event">
    </app-cv-input>
  </div>

  <div class="form-row margintop10px">
    <mat-form-field class="col-4-1">
      <input matInput placeholder="Average" [(ngModel)]="ingredient.average" name="average" />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <input matInput placeholder="Low" [(ngModel)]="ingredient.low" name="low" />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <input matInput placeholder="High" [(ngModel)]="ingredient.high" name="high" />
    </mat-form-field>

    <app-cv-input class="col-4-1" domain="PROD_UNIT" title="Unit" name="unit" [model]="ingredient.unit"
      (valueChange)="ingredient.unit = $event">
    </app-cv-input>
  </div>

  <div class="form-row margintop10px">
    <mat-form-field class="col-4-1">
      <input matInput placeholder="Original Numerator Number" [(ngModel)]="ingredient.originalNumeratorNumber"
        name="originalNumeratorNumber" />
    </mat-form-field>

    <app-cv-input class="col-4-1" domain="PROD_UNIT" title="Original Numerator Unit" name="originalNumeratorUnit"
      [model]="ingredient.originalNumeratorUnit" (valueChange)="ingredient.originalNumeratorUnit = $event">
    </app-cv-input>

    <mat-form-field class="col-4-1">
      <input matInput placeholder="Original Denominator Number" [(ngModel)]="ingredient.originalDenominatorNumber"
        name="originalDenominatorNumber" />
    </mat-form-field>

    <app-cv-input class="col-4-1" domain="PROD_UNIT" title="Original Denominator Unit" name="originalDenominatorUnit"
      [model]="ingredient.originalDenominatorUnit" (valueChange)="ingredient.originalDenominatorUnit = $event">
    </app-cv-input>
  </div>

  <div class="form-row">

    <mat-form-field class="col-4-1">
      <input matInput placeholder="Manufacturer" [(ngModel)]="ingredient.manufacturer" name="manufacturer" />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <input matInput placeholder="Manufacture Ingredient Catalog ID"
        [(ngModel)]="ingredient.manufactureIngredientCatalogId" name="manufactureIngredientCatalogId " />
    </mat-form-field>

    <mat-form-field class="col-4-2">
      <input matInput placeholder="Manufacture Ingredient URL" [(ngModel)]="ingredient.manufactureIngredientUrl"
        name="manufactureIngredientUrl " />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field class="col-4-1">
      <input matInput placeholder="Lot No" [(ngModel)]="ingredient.ingredLotNo" name="ingredLotNo" />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <input matInput placeholder="Confidentiality Code" [(ngModel)]="ingredient.confidentialityCode"
        name="confidentialityCode" />
    </mat-form-field>

    <mat-form-field class="col-4-2">
      <input matInput placeholder="Notes" [(ngModel)]="ingredient.notes" name="notes " />
    </mat-form-field>
  </div> <!-- row-->

</fieldset>
<br>